import React from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';

import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import EditProfileForm from './components/EditProfileForm';
import { UPDATE_USER } from './ProfileGraphQL';

const validationSchema = Yup.object({
  name: Yup.string('Enter your name').required('Name is required'),
  email: Yup.string('Enter your email')
    .email('Enter a valid email')
    .required('Email is required'),
  phone: Yup.number('Enter your phone number'),
  role: Yup.string('Enter your role').required('Role is required'),
  organization: Yup.string('Enter your organization').required(
    'organization is required',
  ),
});

const MyProfileForm = ({ auth, setAuthData }) => {
  const { email, userName, role, orgName, userId, phone } = auth;
  const initialValues = {
    name: userName,
    email,
    phone: phone || '',
    role,
    organization: orgName,
  };
  const [updateUser] = useMutation(UPDATE_USER, {
    onCompleted: ({ updateUser: updateUserResponse }) => {
      if (updateUserResponse) {
        setAuthData({
          ...auth,
          userName: updateUserResponse.name,
          phone: updateUserResponse.phone,
        });

        toast.success('Profile successfully updated.');
      }
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.forEach(({ message, extensions: { code } }) => {
        if (code === 'INTERNAL_SERVER_ERROR') toast.error(message);
      });
    },
  });

  const handleEditProfile = async (values) => {
    await updateUser({
      variables: { ...values, id: userId },
    });
  };
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleEditProfile}
      validationSchema={validationSchema}
      children={(props) => <EditProfileForm {...props} />}
    />
  );
};

export default MyProfileForm;
